import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';
import { finalize, Observable } from 'rxjs';

/**
 * Counts a request in and out of the loading bar.
 *
 * The auto flag is read straight off the signal. It used to be pulled out of an
 * observable with `take(1).subscribe()` into a local, which worked only because
 * `BehaviorSubject` happens to emit synchronously — a subscription whose whole purpose
 * was to read one value.
 */
export const fuseLoadingInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loading = inject(FuseLoadingService);

  if (!loading.auto()) {
    return next(req);
  }

  loading.requestStarted(req.url);

  // `finalize` covers success, error and cancellation, so the count cannot drift.
  return next(req).pipe(finalize(() => loading.requestFinished(req.url)));
};
